// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4816":"1df5b0cc","5344":"9f7100d9","6145":"1df5b0cc","7070":"5ba0603a","7242":"5ba0603a","8919":"1df5b0cc","9089":"1df5b0cc"}[chunkId] + ".chunk.css";
};